import { DOC } from "./actions";
import initialState from "../../../../reducers/initialState";

const TechnicalDocsReducer = (state = initialState, action) => {
  switch (action.type) {

  

    case DOC.UPDATE_WAITING_CONTRACT_SUBJECT_LIST: {
      return {
        ...state,
        WaitingDocumentList: action.data,
      };
    }
    case DOC.UPDATET_DOC_LIST: {
      return {
        ...state,
        DocList: action.data,
      
      };}

      case DOC.ADD_NEW_DOC:{
        return {
          ...state,
          isAddNewDoc : !state.isAddNewDoc,
        
        }
      }
      case DOC.UPDATE_DOC_GROUP: {
        return {
          ...state,
          docGroup: action.data,
        
        };}
        case DOC.FILTER_DOC_LIST:{
          return {
           ...state,
            filteringDocs: !state.filteringDocs,
            
           
          }
        }
        case DOC.ISFILTERED_DOC_LIST:{
          return {
           ...state,
           isFiltered: !state.isFiltered,
            
           
          }
        }

        case DOC.EDIT_DOC:{
          return {
            ...state,
            isEditDoc: !state.isEditDoc,
      
          }
        }

        case DOC.UPDATE_SELECTED_DOC:{
          return {
            ...state,
            isEditDoc : !state.isEditDoc,
            selectedDoc: action.data,
           

        
          }
        }
        case DOC.ADD_NEW_REVISION:{
          return {
            ...state,
            isAddRevision : !state.isAddRevision
          }
        }
        case DOC.UPDATE_DOC_INPROGRESS_LIST:{
          return{
            ...state,
            docInprogressList : action.docInprogressList
          }
        }
        case DOC.UPDATE_SELECTED_REV:{
          return{
            ...state,
            selectedRev : action.selectedRev
          }
        }
        case DOC.RESET_REV_STATE:{
          return{
            ...state,
            selectedRev : {}
          }
        }

        case DOC.UPDATE_REV_ACTIVITY:{
        return{
          ...state,
          activityList : action.activityList
        }
        }

        case DOC.UPDATE_SELECTED_ACTIVITY:{
          return{
            ...state,
            selectedActivity : action.selectedActivity,
            openTimesheetModal:true
          }
          }

          case DOC.CLOSE_TIMESHEET_MODAL:{
            return{
              ...state,
             
              openTimesheetModal:false,
              selectedActivity:{}

            }
            }

            case DOC.OPEN_FINALIZING_MODAL:{
              return{
                ...state,
               
                openFinalizingModal: !state.openFinalizingModal,
                finalTemp: action.finalTemp
              }
              }
              case DOC.UPDATE_USER_LIST:{
                return{
                  ...state,
                  userList : action.userList,
                  
                }
                }

                case DOC.UPDATE_SELECTED_PENDING_REV:{
                  return{
                    ...state,
                    selectedPendingRev: action.selectedPendingRev,
                    openPendingRevModal: !state.openPendingRevModal
                  }
                }
                case DOC.OPEN_PENDING_REV_MODAL:{
                  return{
                    ...state,
                   
                    openPendingRevModal: !state.openPendingRevModal,
                  }
                  }
                  case DOC.VIEW_DOC_ARCHIVE:{
                    return {
                      ...state,
                      
                      selectedDoc : action.data
                    }
                  }
                  case DOC.VIEW_DOC_HISTORY:{
                    return {
                      ...state,
                      
                      openDocHistory : !state.openDocHistory
                    }
    }
       case DOC.TOGGLE_REV_EDIT_MODAL:{
                    return {
                      ...state,
                      
                      revEditModal : !state.revEditModal
                    }
                  }

    default:
      return state;
  }
};

export default TechnicalDocsReducer;
